<script lang="ts">
  import { _, date as formatDate } from 'svelte-i18n';
  import Select from 'svelte-select';
  import ExerciseCard from '../ExerciseCard/ExerciseCard.svelte';
  import FilterModal from '../FilterModal.svelte';
  import route from '../Util/routes';
  import { getRequest, getDiamondFromDifficulty, containsQueryRT, playSessionNow, isUserInSession, parseStorage } from '../Util/utils';
  import type { CalendarEventBody } from '../Util/api'
  import { createCalendarEvent, deleteCalendarEvent } from '../Util/api'
  import type { MyFitnessStores } from './stores';
  import { time_update_minute as current_time } from '../time';
  import { customFlip, type XSSDetails, isActivityCompleted, debouncer, forecastTargetsApplyOn } from '../Util/utils';
  import { format, differenceInDays, isPast, isToday, isTomorrow, isValid, startOfDay } from 'date-fns';
  import { toggledRestActivityBody, ReccTrainingPills } from '@/Common/constants';
  import { createEventDispatcher, getContext, setContext } from 'svelte';
  import { type Writable, writable } from 'svelte/store';
  import { bootstrapTooltip } from './../Bootstrap';
  import DayAvailabilityPopover from './Calendar/DayAvailabilityPopover.svelte';

  // TODO: Remove this component, use ChooseTrainingView instead

  export let myFitness: MyFitnessStores;
  export let likeScore: number;
  export let dislikeScore: number;
  export let setIsLoading: (value: boolean) => void = (v) => {};

  //These are only used in the instances where you can select workouts from the recommended training panel by clicking on the card (ex. calendar)
  export let isCalendarPicker: boolean = false;
  export let calendarPickerIsPast: boolean = false;
  export let highlightSelected: boolean = true;
  export let selected_path: string | null = null;
  export let calendarSelectedDate: any | null = null;
  export let isRestToggleState = false;
  export let isAdditionalTraining = false;
  export let sport = null;
  export let forcedPill: { label: string; value: number; exerciseType: string; activityType: string; } | null = null;
  // For bind only, not a prop
  export let selected_path_type: string | null = null;
  
  //@ts-ignore
  const Xert = window.Xert;

  const { selectedTrainingPlan, trainingPlan } = myFitness;

  const filterKey = `rtFilter`;

  let selectedPill = parseStorage(filterKey).selectedPill ? ReccTrainingPills[parseStorage(filterKey).selectedPill] : ReccTrainingPills[0];
  $: effectivePill = forcedPill ?? selectedPill;
  $: exerciseType = effectivePill.exerciseType;
  $: activityType = effectivePill.activityType;
  let exercises: any = null;
  let trainingAdvice: any = null;
  let displayExercises = [];
  let next: any;
  let title: string;
  let exercisesToShow = 4;

  // Export caught by bind in CalendarAddModal.svelte
  export let selected_exercise: any | null = null;
  let shouldShowSelectedExercise: boolean = true
  $: nextTrainingIsToday = selectedDate && isToday(selectedDate) && next && !next?.start_date // Exercises selected using "Play now" have no start date, but must be today

  let showFullDate: boolean = false;

  $: selected_exercise = exercises?.find(exercise=>exercise.path == selected_path)

  $: shouldShowSelectedExercise = forecastTargetsApplyOn($trainingPlan, $selectedTrainingPlan?.start_date ?? calendarSelectedDate)
  $: if (shouldShowSelectedExercise) {
    selected_path = ($selectedTrainingPlan?.related_activity_id || $selectedTrainingPlan?.workout_id) ?? null
  }

    const dispatch = createEventDispatcher();
    const pinnedState = 'pinned';
    if(!isCalendarPicker) setContext('modal_activity', selectedTrainingPlan);
    $:if(!isCalendarPicker){
            if($selectedTrainingPlan && !($selectedTrainingPlan?.state?.includes('placeholder') ?? true)){ 
                if(Object.hasOwn($selectedTrainingPlan, 'isPinned') ){
                dispatch('lockEvent', $selectedTrainingPlan);
            }
            else{
                $selectedTrainingPlan.isPinned = $selectedTrainingPlan?.state?.includes(pinnedState);
            }
        };
    }

  let selectParent: HTMLElement;
  let durationDropdown = [
    { label: 'None', value: 0 },
    { label: '< 30 Minutes', max: 30, value: 1 },
    { label: '30 Min - 1 Hour', min: 30, max: 60, value: 2 },
    { label: '1 - 1.5 Hours', min: 60, max: 90, value: 3 },
    { label: '1.5 - 2 Hours', min: 90, max: 120, value: 4 },
    { label: '> 2 Hours', min: 120, value: 5 },
  ];
  let selectedDurationDropdown = durationDropdown[0];
  $: if (selectParent) {
    let label = selectParent.getElementsByClassName('selection')[0];
    if (label) {
      if (durationManuallyChanged) {
        label.innerHTML = 'Duration Filter Applied';
      } else if (selectedDurationDropdown.value == 0 && selectParent) {
        window.setTimeout(() => {
          label.innerHTML = 'Select Duration';
        }, 0);
      } else {
        // Reapply default label since it may have been overridden previously.
        label.innerHTML = selectedDurationDropdown.label;
      }
    }
  }

  const onApply = () => {
    let needSort = true
    searchQuery = searchBox;
    if (recentsOnly != showRecentsOnly) {
      recentsOnly = showRecentsOnly;
      reloadExercises();
      needSort = false
    }

    showPreferredExercisesOnly = showLikedOnly && showFavouritesOnly && !showDislikedOnly

    // if (durationManuallyChanged && minDuration == null && maxDuration == null) {
    if (minDuration == null && maxDuration == null) {
      // Reset duration selection.
      durationManuallyChanged = false;
      selectedDurationDropdown = durationDropdown[0];
    }

    if (needSort) runExerciseSort()
  };

  const reactToSelectionDropdown = (value) => {
    if (value != 0) {
      minDuration = selectedDurationDropdown.min;
      maxDuration = selectedDurationDropdown.max;
      durationManuallyChanged = false;
    } else if (!durationManuallyChanged) {
      minDuration = null;
      maxDuration = null;
    }
    runExerciseSort()
  };
  $: reactToSelectionDropdown(selectedDurationDropdown.value);

  $: if (exercises != null) {
    // exercises
    activityType
    exerciseType
    runExerciseSort()
  }

  function runExerciseSort () {
    if (!exercises) {
      return;
    }
    exercises.forEach(e => delete e.start_date)
    let sortedExercises = (exerciseType == 'All') ? (calendarPickerIsPast ? exercises.filter(exercise=>exercise.exerciseType !== 'Session') : exercises) : exercises.filter(exercise=>exercise.exerciseType == exerciseType);

    // Select Workout Source
    let owners: { [type: string]: boolean } = {
      Admin: showStandard,
      Coach: showCommunity,
      User: showPersonal,
    };

    //Select Session Source
    let sessionType: { [type: string]: boolean } = {
      Standard: showStandard,
      Community: showCommunity,
      Personal: showPersonal,
    };
    sortedExercises = sortedExercises.filter((exercise) => {
      return !exercise.exerciseType || (exercise.exerciseType == 'Activity' && (!activityType || activityType == exercise.venue)) || (exercise.exerciseType != 'Session' && owners[exercise.owner]) || (exercise.exerciseType == 'Session' && (!exercise.isTemplate || sessionType[exercise.session_type]));
    });

    // Filter by duration
    if (minDuration || maxDuration) sortedExercises = sortedExercises.filter((workout) => (!minDuration || workout.duration / 60 >= minDuration) && (!maxDuration || workout.duration / 60 <= maxDuration));

    // Filter by XSS
    if (minXSS || maxXSS) sortedExercises = sortedExercises.filter((workout) => (!minXSS || workout.xss >= minXSS) && (!maxXSS || workout.xss <= maxXSS));

    // Filter by focus
    let focuses = ['', 'Power Sprinter', 'Road Sprinter', 'Pursuiter', 'Puncheur', 'Breakaway Specialist', 'Rouleur', 'GC Specialist', 'Climber', 'Endurance'];
    if (selectedFocus && selectedFocus.value != 0) sortedExercises = sortedExercises.filter((workout) => workout.focus == focuses[selectedFocus.value]);

    // Filter by specificity
    let specificity = ['', 'Pure', 'Mixed', 'Polar']
    if (selectedSpecificity && selectedSpecificity.value != 0) sortedExercises = sortedExercises.filter((workout) => workout.specRating == specificity[selectedSpecificity.value]);

    // Filter by difficulty
    if (minDiamonds || maxDiamonds) sortedExercises = sortedExercises.filter((workout) => (!minDiamonds || getDiamondFromDifficulty(workout.difficulty) > (minDiamonds.value + 2) / 2) && (!maxDiamonds || getDiamondFromDifficulty(workout.difficulty) <= (maxDiamonds.value + 2) / 2));

    // Like Only or Favourties only
    if(showLikedOnly || showFavouritesOnly) sortedExercises = sortedExercises.filter(workout => (showLikedOnly && workout.liked) || (showFavouritesOnly && workout.favorite));

    // Dislike Only
    if(showDislikedOnly) sortedExercises = sortedExercises.filter(workout => workout.disliked);

    // Apply Search Query
    let queryArray = searchQuery?.match(/("[^"]+")|([^ ]+)/g) ?? null;
    //split the query by spaces, but ignore spaces if surrounded by quotes
    if (queryArray !== null && queryArray.length !== 0) {
      queryArray.forEach((q) => {
        if (q.at(0) === '"') {
          //check to see if it starts with a quote, as the splitting process leaves surrounding quotes in
          q = q.replace(/"(.)*"/, q.substring(1, q.length - 1));
        }
        sortedExercises = sortedExercises.filter((workout) => containsQueryRT(workout, q));
      });
    }
    // Sort by recommended; most to least
    sortedExercises.sort((left, right) => {
      return left.advisorScore - right.advisorScore;
    });

    displayExercises = sortedExercises;
  }

  // Modal vars
  let searchBox: string;
  let showLikedOnly: boolean = parseStorage(filterKey).showLikedOnly ?? false;
  let showDislikedOnly: boolean = parseStorage(filterKey).showDislikedOnly ?? false;
  let showFavouritesOnly: boolean = parseStorage(filterKey).showFavouritesOnly ?? false;
  let recentsOnly: boolean = parseStorage(filterKey).showRecentsOnly ?? true;
  let showRecentsOnly: boolean = parseStorage(filterKey).showRecentsOnly ?? true;
  let searchQuery: string = parseStorage(filterKey).searchBox ?? '';
  let minDuration: number;
  let maxDuration: number;
  let durationManuallyChanged = false;
  let minXSS: number;
  let maxXSS: number;
  let selectedFocus;
  let selectedSpecificity;
  let minDiamonds;
  let maxDiamonds;

  let showPreferredExercisesOnly: boolean
  $: {
    if (showPreferredExercisesOnly) {
      showLikedOnly = true
      showDislikedOnly = false
      showFavouritesOnly = true
    } else {
      showLikedOnly = false;
      showDislikedOnly = false;
      showFavouritesOnly = false;
    }
    runExerciseSort()
  }

  let showStandard: boolean;
  let showCommunity: boolean;
  let showPersonal: boolean;

  let dateToSchedule: Date | null = null;
  let day: String = 'Today';
  let selectedDate: Date = null;
  let targetXSS: XSSDetails | null = null



  $: noActivity = $selectedTrainingPlan?.state && ($selectedTrainingPlan.state.findIndex(v=>['none', 'rest', 'recovery'].includes(v)) >= 0)

  let exercisesLoading = false;
  let isForecast:Writable<any> = getContext('training_plan_is_forecast') ?? writable(null);
  async function onScheduleCallback(body: CalendarEventBody) {
    
    setIsLoading(true)
    // the handler (ForecastTraining.svelte) will clear its load state on its own

    // if ($selectedTrainingPlan?.state?.includes('forecast')) {
    if ($isForecast?.isForecastPlan && (($selectedTrainingPlan?.state?.includes('scheduled')) || $selectedTrainingPlan?.state?.includes('placeholder'))) {
      body.options = {
        edit_id: $selectedTrainingPlan.path,
        planned: true, // Allow scheduling in the past? TODO: Is this needed?
        state: $selectedTrainingPlan?.state?.includes('forecast')? ['forecast', 'scheduled'] : ['scheduled']
      }
      // NOTE: Schedule button doesn't set the exercise as the selected exercise on its own, so that's done here.
      selected_path = body.id
      selected_path_type = body.type
    } else {
        body.options = { state: ['scheduled'] }
    }
    body.options.state.push('recommended')
    await createCalendarEvent(body)
  }

  function pickForecastExercise(activity) {
    const newDate = new Date(activity.start_date);
    showFullDate = activity.showFullDate ?? false;
    if (activity.start_date && isValid(newDate)) {
      day = isToday(newDate) ? "Today" : (isTomorrow(newDate) ? "Tomorrow" : format(newDate, "EEEE"));
      // reloadDebouncer.debounce(reloadExercises);
      reloadExercises();
    }
  }

  let prevSelectedTrainingPlan = null
  let prevCalendarSelectedDate = null
  $: {
    if ($selectedTrainingPlan) {
      // Show recommended workouts based on training plan.
      // Don't reload if same activity re-selected.
      if (!prevSelectedTrainingPlan || $selectedTrainingPlan.path != prevSelectedTrainingPlan.path) {
        pickForecastExercise($selectedTrainingPlan)
      }
      isRestToggleState = !($selectedTrainingPlan.state?.includes('rest') || $selectedTrainingPlan.state?.includes('recovery')) && $selectedTrainingPlan.xss === 0 ;// && !$selectedTrainingPlan?.sessions
      disableRestToggle = false
    } else if (!prevCalendarSelectedDate || calendarSelectedDate.getTime() != prevCalendarSelectedDate.getTime()) {
      // Show basic recommended workouts based on training advisor.
      // reloadDebouncer.debounce(reloadExercises);
      reloadExercises();
    }
    prevSelectedTrainingPlan = $selectedTrainingPlan
    prevCalendarSelectedDate = calendarSelectedDate ?? null
  }
  $: isTrainingCompleted = ($selectedTrainingPlan && isActivityCompleted($selectedTrainingPlan))

  async function getExercises() {

    if ($selectedTrainingPlan && !$selectedTrainingPlan.state?.includes('none')) {
      let parsedDate = $selectedTrainingPlan.start_date_local // Start date local is probably wrong, backend formats this as UTC even though it isn't
      if ($selectedTrainingPlan.start_date) parsedDate = $selectedTrainingPlan.start_date
      dateToSchedule = null
      if (Date.parse(parsedDate) >= Date.now()) {
        dateToSchedule = new Date(parsedDate)
      }
      selectedDate = new Date(parsedDate);
    } else {
      dateToSchedule = null
      selectedDate = calendarSelectedDate ? new Date(calendarSelectedDate) : new Date()
    }

    const arg_date = new Date(selectedDate.getTime())
    const response = await(await window.fetch('recommended-training?' + new URLSearchParams({
                    recent: recentsOnly.toString(),
                    date: arg_date?.toISOString() ?? '',
                    additional: isAdditionalTraining.toString(),
                    sport,
                }), {method: 'GET', 
      ...getRequest()})).json();
    exercises = response?.exercises
    trainingAdvice = response?.training_advice

    if ($selectedTrainingPlan?.state?.includes('placeholder')) {
        targetXSS = {
            xss: $selectedTrainingPlan.xss,
            xlss: $selectedTrainingPlan.xlss,
            xhss: $selectedTrainingPlan.xhss,
            xpss: $selectedTrainingPlan.xpss,
        }
    } else if ($selectedTrainingPlan?.placeholder_xss_details) {
        targetXSS = $selectedTrainingPlan.placeholder_xss_details
    } else {
        targetXSS = null
    }
  }

  $: {
    if (next) {
      if (next.inProgress) {
        if (next.exerciseType == 'Session') {
          title = (next.is_group_session ? 'Group ' : 'Solo ') + next.exerciseType + ' In Progress';
        } else {
          title = next.exerciseType + ' In Progress - ' + (next.isUserSelected ? 'Selected' : 'Scheduled');
        }
      } else if (next.isReady) {
        let source = next.isSuggested ? 'Suggested' : next.start_date ? 'Planned' : 'Selected';
        title = (next.exerciseType == 'Session' ? (next.is_group_session ? 'Group ' : 'Solo ') : '') + next.exerciseType + ' Ready: ' + source;
      } else {
        title = 'Next ' + next.exerciseType;
      }
    } else {
      title = null;
    }
  }

  let promiseMessage = '';

  const _reloadExercises = async () => {
    exercisesLoading = true;
    promiseMessage = exercises != null ? $_('training.wait_exercises') : $_('training.wait_exercises_first_load');
    
    await getExercises()

    exercisesLoading = false;
    // isGeneratingWorkout = false;
  };
  let exercisesPromise: Promise<any>;

  const reloadExercises = () => {
    if (($trainingPlan && $trainingPlan.has_training_forecast && !$selectedTrainingPlan) && !isCalendarPicker) {
        exercisesPromise = Promise.resolve(1);
    }
    else exercisesPromise = _reloadExercises();
  };

  const clearExercise = async ()=>{
    if (isCalendarPicker) {
      selected_path = null
      selected_path_type = null
    }
  }


  async function joinExerciseById(session_id: string, force: boolean, action: string) {
    return await window.fetch(`${Xert.Sessions.urls.create}/${session_id}/${action}`, {
      ...getRequest(),
      method: 'post',
      body: JSON.stringify({ resolve_conflicts: force ?? false }),
    });
  }

  function handleLikeChange(event) {
    let key = event.detail.path + event.detail.exerciseType;
    let index = exercises.findIndex((exercise) => key === exercise.path + exercise.exerciseType);
    exercises[index].liked = event.detail.liked;
    exercises[index].disliked = event.detail.disliked;
    const indexedExercise = exercises[index];
    exercises[index].advisorScore = indexedExercise.baseScore + indexedExercise.liked * likeScore + indexedExercise.disliked * dislikeScore;
    exercises = exercises;
  }

  // Binding variables
  let btnRowWidth: number;
  let btnRowSize: ResizeObserverSize[];
  $: if (btnRowSize && btnRowSize.length > 0) {
    btnRowWidth = btnRowSize[0].inlineSize;
  }

let reccomendedTrainingSize:ResizeObserverSize[] = [{blockSize: 0, inlineSize: 0} as ResizeObserverSize];
// $:  useAutogenIcon = reccomendedTrainingSize[0].inlineSize < 520; // 310px

  const openVideoPlayer = () => {
    window.open(route('RemotePlayerController@getVideoPlayer'), '_remote');
    return Promise.resolve();
  };

  const onExerciseCardClick = (exercise: any): void => {
    if (!isCalendarPicker) return;
    selected_path = exercise.path;
    selected_exercise = exercises?.find(exercise=>exercise.path == selected_path)
    selected_path_type = exercise.exerciseType;
    isRestToggleState = false
  };

  const joinSession = async (session_id, force, exercise: any) => {
    await joinExerciseById(session_id, force, isUserInSession(exercise) ? 'leave' : 'join');
  };

  const playWorkoutNow = async (exercise) => {
    next = exercise;
    next.isReady = true;
    next.isSelected = true;

    if(isRestToggleState) await defaultRestToggleHandler(false);

    let response = await selectExercise(exercise)

    // Trigger update to trainingPlan so that the 3-day forecast is updated with new selected exercise
    if ($trainingPlan) {
      trainingPlan.set($trainingPlan)
    }

     return response.ok? Promise.resolve():Promise.resolve(new Error('selection failed'));
  };

  let disableRestToggle = false;
  const defaultRestToggleHandler = (value) => {
    disableRestToggle = true
    let promise
    if (value) {
      const body = toggledRestActivityBody(selectedDate)
      promise = onScheduleCallback(body)
    } else {
      setIsLoading(true)
      // the handler (ForecastTraining.svelte) will clear its load state on its own
      promise = deleteCalendarEvent($selectedTrainingPlan.path)
    }
    promise.then(() => {disableRestToggle = false})
  }

  const onRestToggle = (e) => {
    const value = e.currentTarget.checked
    if (value) {
        selected_path = null
        selected_path_type = null
    }
    isRestToggleState = value
    if (!isCalendarPicker) defaultRestToggleHandler(value)
  }

  let titleToShow = 0
  $: if ((!shouldShowSelectedExercise || nextTrainingIsToday) && !isCalendarPicker && next && next.exerciseType && (!next.start_date || $current_time.getTime()+1000*60*60*24*7 > (new Date(next.start_date)).getTime())) {
    titleToShow = 0
  } else if (selected_exercise && highlightSelected && (isCalendarPicker || shouldShowSelectedExercise)) {
    titleToShow = 1
  } else {
    titleToShow = 2
  }


  $: isForecastActivity = $selectedTrainingPlan?.state?.includes('forecast') && !$selectedTrainingPlan?.state?.includes('completed');

    function scrollIntoView() {
        const el = document.querySelector('.scroll-to-title');
        if (!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }

    function clickExerciseCard(exercise){
        return ()=>{
            onExerciseCardClick(exercise);
            scrollIntoView();
        }
    }

</script>

<div id={`recc-training-${!isCalendarPicker && 'main'}`} bind:borderBoxSize={reccomendedTrainingSize} on:likechange={handleLikeChange} class="box-solid list-holder workout_block"> 
  <div class="portlet light portlet-fit bordered">
    <div class="portlet-title title-override relative">
        <div class="title_container scroll-to-title w-max mr-auto">
            <span>
                <span class="!leading-normal caption-subject box_header text-center">
                    {#if titleToShow==0}
                        {title}
                    {:else if titleToShow==1}
                        {`${$formatDate(selectedDate, {day: '2-digit', month: 'short', year: 'numeric' })} - ${selected_exercise.exerciseType}${isPast(selectedDate) ? '' : ' Selected'}`}
                    {:else}
                        {#if !noActivity && isTrainingCompleted}
                            Training Completed - Additional Training
                        {:else if !isAdditionalTraining && (isCalendarPicker || differenceInDays(selectedDate, startOfDay(new Date())) > 7)}
                            Recommended Training for {$formatDate(selectedDate, { day: '2-digit', month: 'short', year: 'numeric' })}
                        <!-- NOTE: Scheduling in the past from the training tab should still say today's training -->
                        <!-- {:else if !dateToSchedule}
                            Recommended Training -->
                        {:else if isAdditionalTraining || noActivity}
                            Additional Training
                        {:else}
                            {day}'s Recommended Training
                        {/if}
                    {/if}
                </span>
            </span>
        </div>
        {#if $selectedTrainingPlan?.state?.includes('forecast') &&!$selectedTrainingPlan.state.includes('completed') && !$selectedTrainingPlan.state.includes('rest') && !$selectedTrainingPlan.state.includes('recovery') && ($selectedTrainingPlan.state.includes('placeholder') || $selectedTrainingPlan.placeholderXSSDetails?.xss!==0)}
            <!-- if forecast event [forecast], if either non-rest placeholder [placeholder & !rest], or selected for a non-rest placeholder [has placeholder details, but it is 0] -->
            <div class="toggle-wrapper ml-auto">
                <input disabled={disableRestToggle} checked={isRestToggleState} type="checkbox" id={`toggle-rest-1-${isCalendarPicker ? 'cal' : ''}`} on:change={onRestToggle} /><label for={`toggle-rest-1-${isCalendarPicker ? 'cal' : ''}`}/>
                <small class="ml-[10px]">Rest Day</small>
            </div>
        {:else if trainingAdvice?.is_availability_restricted}
          <DayAvailabilityPopover date={calendarSelectedDate ?? new Date()} showScope asModal onSaved={reloadExercises} let:builder>
            <button {...builder} use:builder.action
              class='text-yellow-600 bg-transparent border-none hover:bg-gray-300 transition-all m-0 rounded-md px-3'
              use:bootstrapTooltip={{
                title: "Your recommended training has been restricted by your availability settings. Click to modify them.",
              }}
            >
              <i class="fa-regular fa-clock" /> Restricted
            </button>
          </DayAvailabilityPopover>
        {/if}
    </div>
    {#if titleToShow==1}
      <div class="py-[10px] px-[15px]">
        <!-- Calendar Modal: I'm removing the clear button from here, it should be somewhere in the modal footer insted -->
        <ExerciseCard {selectedDate} isCalendarCard={isCalendarPicker} isPlanned={true} {targetXSS} {onScheduleCallback} {...selected_exercise} showClearButton={true} {clearExercise} playSessionNow={openVideoPlayer} showPlayButton={selected_exercise.exerciseType == 'Workout' && selectedDate && isToday(selectedDate) && !isCalendarPicker} showScheduleButton={false} isTrainingPicker={true} />
      </div>
    {/if}

    {#if exercisesLoading}
      <div class="p-[16px] mt-[16px] mx-auto w-min text-center">
        <i style="color: var(--color-xert-teal); font-size: 32px; flex: 0 0 0;" class="fas fa-circle-notch fa-spin" />
        <div class="pt-[12px] whitespace-nowrap">{promiseMessage}</div>
      </div>
    {:else}
      <div class="btn-row" bind:borderBoxSize={btnRowSize} style={'border-bottom: none; display: flex; justify-content: space-between; flex-wrap: wrap;'}>
        <span class="recc-training-buttons" style={btnRowWidth < 675 ? 'flex-grow: 1;' : ''}>

          <span class="searchbar">
            <input type=text on:keypress={(e) => {if(e.key == 'Enter') onApply()}} bind:value={searchBox} placeholder="Text Search"/>
            <button id="searchbtn" on:click={onApply}>
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </span>

          <span class="duration-selector" bind:this={selectParent}>
            <Select isClearable={false} isSearchable={false} isDisabled={durationManuallyChanged} bind:value={selectedDurationDropdown} items={durationDropdown} showIndicator={true} indicatorSvg={'<i class="fa fa-angle-down" style="color: var(--color-xert-gray); top: 0px; height: 100%; line-height: var(--height);"/>'} />
          </span>

          <div class="toggle-wrapper">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <a  title='Show Favourites/Likes only'
                class='text-black'
                href={null}
                on:click={() => showPreferredExercisesOnly = !showPreferredExercisesOnly}
            >
                {#if showPreferredExercisesOnly}
                    <i class="fas fa-xl fa-star" style="color: #fdd835;" />
                {:else}    
                    <i class="fal fa-xl fa-star" />
                {/if}
            </a>
            <!-- <input id={'RT-prefonly-toggle-' + key} type="checkbox" bind:checked={showPreferredExercisesOnly} />
            <label for={'RT-prefonly-toggle-' + key} /> -->
          </div>

          <FilterModal {filterKey} {onApply} title="Filter Recommended Training" showSource={true} showLikedDisliked={true} bind:selectedPill bind:searchBox bind:minDuration bind:maxDuration bind:minXSS bind:maxXSS bind:selectedFocus bind:selectedSpecificity bind:minDiamonds bind:maxDiamonds bind:durationManuallyChanged bind:showStandard bind:showCommunity bind:showPersonal bind:showFavouritesOnly bind:showRecentsOnly bind:showLikedOnly bind:showDislikedOnly />
        </span>
        {#if !forcedPill}
          <div class="selector">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <tag class="all" class:not-selected={selectedPill.value != 0} on:click={() => selectedPill = ReccTrainingPills[0]}>All</tag>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <tag class="workout" class:not-selected={selectedPill.value != 4} on:click={() => selectedPill = ReccTrainingPills[4]}>Workouts</tag>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <tag
              class="outdoor"
              class:not-selected={selectedPill.value != 1}
              on:click={() => selectedPill = ReccTrainingPills[1]}>Outdoor</tag
            >
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <tag
              class="virtual"
              class:not-selected={selectedPill.value != 2}
              on:click={() => selectedPill = ReccTrainingPills[2]}>Virtual</tag
            >
            {#if !calendarPickerIsPast && isCalendarPicker}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <tag class="session" class:not-selected={selectedPill.value != 3} on:click={() => selectedPill = ReccTrainingPills[3]}>Sessions</tag>
            {/if}
          </div>
        {/if}
      </div>
      <div class="portlet-body max-w-full" style="padding: 10px 15px;">
        {#each displayExercises.slice(0, exercisesToShow) as exercise (exercise.path + exercise.exerciseType)}
          <div on:likechange={(e) => e.currentTarget.setAttribute('data-ismoving', true)} animate:customFlip={{ scroll: true }}>
            {#if exercise.exerciseType == 'Workout'}
              <ExerciseCard {selectedDate} isCalendarCard={isCalendarPicker} isPlanned={false} isNext={false} {targetXSS} {onScheduleCallback} selectable={isCalendarPicker} {selected_path} start_date={dateToSchedule} isTrainingPicker={true} {reloadExercises} {...exercise} showScheduleButton={!isCalendarPicker && day != 'Today'} showPlayButton={!isCalendarPicker && day == 'Today'} openPlayerOnPlay={false} playSessionNow={() => playWorkoutNow(exercise)} allowed_to_edit={exercise.owner == 'User'} on:click={clickExerciseCard(exercise)} selectExercise={clickExerciseCard(exercise)} />
            {:else if exercise.exerciseType == 'Activity'}
              <ExerciseCard {selectedDate} isCalendarCard={isCalendarPicker} isPlanned={false} isNext={false} {targetXSS} {onScheduleCallback} selectable={isCalendarPicker} {selected_path} start_date={dateToSchedule} isTrainingPicker={true} {reloadExercises} {...exercise} showScheduleButton={!isCalendarPicker} showPlayButton={false} openPlayerOnPlay={false} playSessionNow={() => playWorkoutNow(exercise)} on:click={clickExerciseCard(exercise)} selectExercise={clickExerciseCard(exercise)} />
            {:else if exercise.exerciseType == 'Session'}
              <ExerciseCard {selectedDate} isCalendarCard={isCalendarPicker} isPlanned={false} isNext={false} {targetXSS} {onScheduleCallback} selectable={isCalendarPicker} {selected_path} start_date={dateToSchedule} isTrainingPicker={true} {reloadExercises} {...exercise} showScheduleButton={!isCalendarPicker && day != 'Today'} showPlayButton={!isCalendarPicker && day == 'Today'} playSessionNow={()=>playSessionNow(exercise)} joinSession={(session_id, force) => joinSession(session_id, force, exercise)} is_group_session={exercise.group_id != null} allowed_to_edit={false} on:click={clickExerciseCard(exercise)} selectExercise={clickExerciseCard(exercise)} />
            {/if}
            <br />
          </div>
        {/each}
        {#if exercises == null}
          <!-- <h4 style="text-align: center; margin-top: 20px;">Loading... Please wait</h4> -->
        {:else if displayExercises.length == 0}
          <h4 style="text-align: center; margin-top: 20px;">
            Nothing found. Check the filter settings.
          </h4>
        {:else if displayExercises.length <= exercisesToShow}
          <h4 style="text-align: center;">You have reached the end of the list</h4>
        {:else}
          <div style="display: flex;">
            <spacer style="flex-grow: 1;" />
            <button
              class="btn"
              on:click={() => {
                exercisesToShow += 4;
              }}>Load More</button>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>


<style lang="scss">
  .forecast-info-toggle {
    all: unset;
    padding: 0px 10px;
    &:hover, &:active, &:focus {
      all: unset;
      padding: 0px 10px;
      cursor: pointer;
      background: #b7b7b7;
    }
  }

  .recc-training-buttons {
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
    padding: 10px 15px;
  }

  .searchbar {
    display: flex;
    padding-top: 4px;
    flex: 10 1 150px;
    min-width: 150px;

    > input {
      min-width: 100px;
      flex-grow: 1;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      height: 30px;
      padding: 2px 12px;
      border: 1px solid var(--color-xert-gray);
      border-top-left-radius: var(--borderRadius) !important;
      border-bottom-left-radius: var(--borderRadius) !important;
      border-right: none !important;
      outline: none;
      color: var(--color-xert-gray-text);
      margin: 10px auto;
    }

    > button {
      height: 30px;
      width: 30px;
      border: 1px solid var(--color-xert-gray-text);
      border-top-right-radius: var(--borderRadius) !important;
      border-bottom-right-radius: var(--borderRadius) !important;
      border-left: none !important;
      background-color: white;
      border-bottom-left-radius: 0px !important;
      border-top-left-radius: 0px !important;

      > i {
        color: #ddd;
      }
    }

    > button:hover {
      background-color: transparent;
      > i {
        color: var(--color-xert-blue);
      }
    }
  }

  .portlet-title {
    display: flex;
    margin-bottom: 0;
    gap: 15px;

    span {
      margin: auto 0;
      line-height: 14px;
    }

    &.title-override {
      padding: 10px 7px;
      &::before {
        content: none;
      }
      &::after {
        content: none;
      }
    }
  }

  .portlet-body {
    max-width: 100%;
  }

  button {
    background: var(--color-xert-teal);
    flex-shrink: 0;
    color: white;
    border-radius: 4px !important;
    height: 37px;
    margin: 10px auto;

    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

    &:hover {
      background: var(--color-xert-lime);
      color: white;
    }
  }

  .duration-selector {
    --height: 35px;
    --padding: 0 10px !important;
    --itemColor: var(--color-xert-gray-text);
    --border: 1px solid var(--color-xert-gray);
    --borderFocusColor: var(--color-xert-gray);
    --borderHoverColor: var(--color-xert-blue);
    --borderRadius: 3px !important;
    --listBorder: 1px solid var(--color-xert-blue);

    --indicatorRight: 20px;
    --indicatorTop: -1px;
    --indicatorHeight: 0;
    --indicatorWidth: 0;

    height: 35px;
    width: 140px;
    margin: auto 0;
  }

  tag {
    color: var(--color-xert-teal);
    border: 1px solid var(--color-xert-teal);
    background: rgba(47, 112, 118, 0.2);
    flex: 0 1 auto;
    border-radius: 90px;
    padding: 9px 18px;
    margin: 2px 0px;
    font-size: 14px;
    line-height: 15px;
    letter-spacing: 0.48px;
    cursor: default;

    text-align: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;

    &.workout {
      color: #5ca907 !important;
      border: 1px solid #5ca907 !important;
      background: rgba(126, 211, 33, 0.2) !important;
    }

    &.outdoor {
      color: #ff2222 !important;
      border: 1px solid #ff2222 !important;
      background: rgba(255, 0, 0, 0.2) !important;
    }

    &.virtual {
      color: #fb6418 !important;
      border: 1px solid #fb6418 !important;
      background: rgba(251, 100, 24, 0.2) !important;
    }

    &.session {
      color: #0b5dbc !important;
      border: 1px solid #0b5dbc !important;
      background: rgba(74, 144, 226, 0.2) !important;
    }

    &.not-selected {
      cursor: pointer !important;
      background: white !important;
    }
  }

  .selector {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: min-content;
    justify-content: center;
    padding: 10px 15px;
    margin: auto;
    gap: 12px;
  }

  .toggle-manual-choose-btn {
    border: 1px solid #3D3D3D !important;
    border-radius: 4px;
    padding: 6px 16px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    width: auto;
    background-color: transparent;
    margin: 0;
    /* identical to box height */

    text-align: center;
    letter-spacing: 0.48px;

    color: #000000;
    cursor: pointer;

    &:hover {
      background-color: transparent;
      color: black;
    }
  }
</style>
